
import React, { Component } from 'react';
import TableView from '../../lib/tables/TableView';
import { Faxes } from '../../services';

class FaxTable extends Component {
  constructor() {
    super();
    this.state = { totalPages: '' };
  }

  componentDidMount(){
    this.getFaxesToDispley()
  }
  getFaxesToDispley(){
    const {rest, setInvoices} = this.props;
    Faxes.getSentFaxes(rest.computedMatch.params.page)
      .then((res) => {
        const totalPages = res.body.meta["total-pages"];
        setInvoices(res.body.data.invoices)
        this.setState({
          totalPages: totalPages,
        })
      }).catch(error => {
      console.log(error);
      });
  }
  render(){
    const headers = [
      "date",
      "sender",
      "destination",
      "email",
      "nb_page",
      "status",
    ]
    return(
      <div id="bills">
        <TableView totalPages={this.state.totalPages} rest={this.props.rest} headers={headers}/>
      </div>
    )
  }
}
export default FaxTable;
    // <InvoiceItems/>



// WEBPACK FOOTER //
// ./src/components/Fax/FaxSended.js